//======================================================================================================
//
// This store will hold information for support requests
//
//======================================================================================================

import { defineStore } from "pinia";
import { SupportRequestType, SupportRequestPayload } from "@/types/support";

import { useApiStore as api } from "./apiStore";

export const useSupportRequestStore = defineStore("supportRequestStore", {
	state: () =>
		({
			isOpen: false
		}) as SupportRequestType,
	actions: {
		close() {
			this.isOpen = false;
		},
		open() {
			this.isOpen = true;
		},
		async submit(payload: SupportRequestPayload) {
			console.log({ _: "Support Request :: submit", payload });

			return new Promise<void>((resolve, reject) => {
				api()
					.post({
						endpoint: "/support-request/create",
						post: payload
					})
					.then(() => {
						resolve();
					})
					.catch((e: any) => {
						console.log(e);
						reject(e);
					});
			});

			this.isOpen = false;
		}
	}
});
